<template>
	<div>
		<div class="content font-class">
			<ul class="icon_lists dib-box">
				<li class="dib">
					<span class="icon iconfont iconstars"></span>
					<div class="name">
						星星
					</div>
					<div class="code-name">.iconstars
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconmore"></span>
					<div class="name">
						more
					</div>
					<div class="code-name">.iconmore
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconedit"></span>
					<div class="name">
						修改
					</div>
					<div class="code-name">.iconedit
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconreduce"></span>
					<div class="name">
						减
					</div>
					<div class="code-name">.iconreduce
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconsave"></span>
					<div class="name">
						分享
					</div>
					<div class="code-name">.iconsave
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconadd"></span>
					<div class="name">
						增加
					</div>
					<div class="code-name">.iconadd
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconsearch"></span>
					<div class="name">
						搜索
					</div>
					<div class="code-name">.iconsearch
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconuser"></span>
					<div class="name">
						用户
					</div>
					<div class="code-name">.iconuser
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconsetting"></span>
					<div class="name">
						设置
					</div>
					<div class="code-name">.iconsetting
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont iconphone"></span>
					<div class="name">
						电 话
					</div>
					<div class="code-name">.iconphone
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont icondelete"></span>
					<div class="name">
						删 除 (1)
					</div>
					<div class="code-name">.icondelete
					</div>
				</li>

				<li class="dib">
					<span class="icon iconfont icontips"></span>
					<div class="name">
						提示
					</div>
					<div class="code-name">.icontips
					</div>
				</li>
				<li class="dib">
					<span class="icon iconfont iconshow"></span>
					<div class="name">
						眼睛
					</div>
					<div class="code-name">.iconshow
					</div>
				</li>
				<li class="dib">
				  <span class="icon iconfont">&#xe607;</span>
				    <div class="name">箭头双右</div>
				    <div class="code-name">&amp;#xe607;</div>
				  </li>
				          
				<li class="dib">
				  <span class="icon iconfont">&#xe608;</span>
				    <div class="name">箭头单右</div>
				    <div class="code-name">&amp;#xe608;</div>
				  </li>
				          
				<li class="dib">
				  <span class="icon iconfont">&#xe609;</span>
				    <div class="name">箭头双左</div>
				    <div class="code-name">&amp;#xe609;</div>
				  </li>
				          
				<li class="dib">
				  <span class="icon iconfont">&#xe60a;</span>
				    <div class="name">箭头 左</div>
				    <div class="code-name">&amp;#xe60a;</div>
				  </li>

			</ul>

		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {};
		},
		mounted() {

		},
		methods: {

		},
		watch: {},
		components: {},
		computed: {},
		updated() {},
		created() {}
	};
</script>
<style>
	@import url("../font_hy/iconfont.css");
	@import url("../font_hy/demo.css");

	.icon_lists li {
		display: inline-block;
	}
</style>
